import type { AddRelacionClienteInmobiliarioInmuebleModel } from '@api/api';
import { TipoRelacionClienteInmobiliarioEnum } from '@api/api';

export class AddRelacionClienteInmobiliarioInmueble implements AddRelacionClienteInmobiliarioInmuebleModel {
    IdClienteInmobiliario: string = null!;
    TipoRelacion: TipoRelacionClienteInmobiliarioEnum = null!;
    FechaInicio: Date | null = null;
    FechaFin: Date | null = null;
    PuedeEnviarAutorizacion: boolean = false;

    constructor(data?: Partial<AddRelacionClienteInmobiliarioInmueble>) {
        Object.assign(this, data);
    }
}